export default "__VITE_ASSET__ef61e04b__"